export function normalizeFocus(value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return 50
  return Math.min(100, Math.max(0, numeric))
}

export default { normalizeFocus }
